import paper from "paper";
import { AWARD_RANK_TO_COLOR, type AwardColor } from "./awardColors";
import type { TreeNodeData } from "../TreeViewDataLayer";
import { calculateWalkerLayout, DEFAULT_WALKER_CONFIG, type WalkerLayoutConfig } from "./walkerLayout";
import { isChinaAff } from "../../ActionReports/common/ActionReportListView/utils/actionReportUtils";

const ellipsesSvg =
  '<svg width="16" height="4" viewBox="0 0 16 4" fill="none"><circle cx="2" cy="2" r="1.5" fill="#2C2C2C"/><circle cx="8" cy="2" r="1.5" fill="#2C2C2C"/><circle cx="14" cy="2" r="1.5" fill="#2C2C2C"/></svg>';
const groupSvg =
  '<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.05531 10.8286C0.195336 9.77842 0.7321 8.84492 1.52558 8.19147C2.24904 7.58469 3.18255 7.21129 4.18606 7.21129H5.25959H6.30978C7.33664 7.21129 8.2468 7.58469 8.97027 8.19147C9.76375 8.84492 10.3005 9.77842 10.4405 10.8286C10.4639 11.0153 10.4639 11.202 10.4639 11.3887C10.4639 11.7621 10.1605 12.0655 9.78708 12.0655H9.32033H1.17551H0.708762C0.335361 12.0655 0.0319724 11.7621 0.0319724 11.3887C0.0319724 11.202 0.0319724 11.0153 0.05531 10.8286ZM2.27238 3.10387C2.27238 2.05368 2.83248 1.0735 3.76599 0.536737C4.67615 -2.69767e-05 5.81969 -2.69767e-05 6.7532 0.536737C7.66336 1.0735 8.2468 2.05368 8.2468 3.10387C8.2468 4.1774 7.66336 5.15758 6.7532 5.69434C5.81969 6.23111 4.67615 6.23111 3.76599 5.69434C2.83248 5.15758 2.27238 4.1774 2.27238 3.10387ZM7.1266 3.10387C7.1266 2.45042 6.7532 1.84364 6.1931 1.49358C5.60966 1.16685 4.88619 1.16685 4.32609 1.49358C3.74265 1.84364 3.39258 2.45042 3.39258 3.10387C3.39258 3.78066 3.74265 4.38744 4.32609 4.7375C4.88619 5.06423 5.60966 5.06423 6.1931 4.7375C6.7532 4.38744 7.1266 3.78066 7.1266 3.10387ZM4.18606 8.33149C3.06586 8.33149 2.08568 8.93827 1.57225 9.8251C1.36221 10.1752 1.22219 10.5486 1.17551 10.9453H2.31906H8.20013H9.32033C9.32033 10.8986 9.32033 10.8286 9.29699 10.7586C9.22698 10.4319 9.11029 10.1285 8.92359 9.8251C8.41017 8.93827 7.42999 8.33149 6.30978 8.33149H4.18606ZM14.2446 12.0655H11.0473C11.164 11.8788 11.234 11.6454 11.234 11.3887C11.234 9.87177 10.5339 8.51819 9.46036 7.60803C9.55371 7.60803 9.64706 7.58469 9.76375 7.58469H11.1873C13.2644 7.58469 14.968 9.28833 14.968 11.3654C14.968 11.7621 14.6413 12.0655 14.2446 12.0655ZM10.1138 6.09108C9.39034 6.09108 8.73689 5.81103 8.2468 5.34428C8.71355 4.71417 8.99361 3.94403 8.99361 3.10387C8.99361 2.49709 8.83024 1.89032 8.55019 1.37689C8.99361 1.0735 9.53037 0.863464 10.1138 0.863464C11.5374 0.863464 12.7276 2.05368 12.7276 3.47727C12.7276 4.9242 11.5374 6.09108 10.1138 6.09108Z" fill="#707070"/></svg>';
const eyeSvg =
  '<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.63507 1.6003C7.43467 1.6003 5.66768 2.60048 4.30077 3.86738C3.00053 5.0676 2.1337 6.46785 1.66695 7.46804C2.1337 8.46822 3.00053 9.90181 4.30077 11.102C5.66768 12.3689 7.43467 13.3358 9.63507 13.3358C11.8021 13.3358 13.5691 12.3689 14.936 11.102C16.2363 9.90181 17.1364 8.46822 17.5698 7.46804C17.1364 6.46785 16.2363 5.0676 14.9694 3.86738C13.5691 2.60048 11.8021 1.6003 9.63507 1.6003ZM3.20057 2.7005C4.76752 1.23357 6.93458 8.22544e-06 9.63507 8.22544e-06C12.3022 8.22544e-06 14.4693 1.23357 16.0362 2.7005C17.6032 4.16743 18.6367 5.86774 19.1368 7.06796C19.2368 7.33468 19.2368 7.63473 19.1368 7.90145C18.6367 9.06833 17.6032 10.802 16.0362 12.2689C14.4693 13.7358 12.3022 14.9361 9.63507 14.9361C6.93458 14.9361 4.76752 13.7358 3.20057 12.2689C1.63361 10.802 0.600091 9.06833 0.1 7.90145C-1.80267e-05 7.63473 -1.80267e-05 7.33468 0.1 7.06796C0.600091 5.86774 1.63361 4.13409 3.20057 2.7005ZM9.63507 10.1352C11.102 10.1352 12.3022 8.96831 12.3022 7.46804C12.3022 6.0011 11.102 4.80088 9.63507 4.80088C9.60173 4.80088 9.56839 4.80088 9.56839 4.80088C9.60173 5.00092 9.63507 5.16762 9.63507 5.33431C9.63507 6.53453 8.66823 7.46804 7.50135 7.46804C7.30131 7.46804 7.13462 7.46804 6.96792 7.40136C6.96792 7.4347 6.96792 7.46804 6.96792 7.46804C6.96792 8.96831 8.1348 10.1352 9.63507 10.1352ZM9.63507 3.20059C11.1353 3.20059 12.5356 4.03408 13.3024 5.33431C14.0692 6.66789 14.0692 8.30152 13.3024 9.60176C12.5356 10.9353 11.1353 11.7355 9.63507 11.7355C8.10146 11.7355 6.7012 10.9353 5.9344 9.60176C5.16759 8.30152 5.16759 6.66789 5.9344 5.33431C6.7012 4.03408 8.10146 3.20059 9.63507 3.20059Z" fill="#38539A"/></svg>';
const plusIconSvg =
  '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><line x1="6" y1="1" x2="6" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="6" x2="11" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
const minusIconSvg =
  '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><line x1="1" y1="6" x2="11" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
const chevronUp =
  '<svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.90234 1.15234C8.21875 0.835938 8.74609 0.835938 9.0625 1.15234L15.8477 7.90234C16.1641 8.25391 16.1641 8.78125 15.8477 9.09766C15.4961 9.44922 14.9688 9.44922 14.6523 9.09766L8.5 2.94531L2.34766 9.09766C1.99609 9.44922 1.46875 9.44922 1.15234 9.09766C0.800781 8.78125 0.800781 8.25391 1.15234 7.9375L7.90234 1.15234Z" fill="#707070"/></svg>';
const chevronDown =
  '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.0859 1.4375L10.6406 0.96875C10.5234 0.851562 10.3359 0.851562 10.2422 0.96875L6 5.21094L1.73438 0.96875C1.64062 0.851562 1.45312 0.851562 1.33594 0.96875L0.890625 1.4375C0.773438 1.53125 0.773438 1.71875 0.890625 1.83594L5.78906 6.73438C5.90625 6.85156 6.07031 6.85156 6.1875 6.73438L11.0859 1.83594C11.2031 1.71875 11.2031 1.53125 11.0859 1.4375Z" fill="#707070"/></svg>';

export type DrawNodeTranslations = {
  confidentialUser: string;
  pabo: string;
  ppv: string;
  gpv: string;
  bonusPercent: string;
};

/**
 * Viewport bounds for culling optimization
 */
export interface ViewportBounds {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
}

const NODE_WIDTH = 260;
const NODE_HEIGHT = 172;
const MIN_SPACING = 44;
// Padding around viewport for rendering nodes slightly outside view (smoother scrolling).
// Wide enough to cover a fast pan between per-frame redraws without a visible pop-in.
const VIEWPORT_PADDING = NODE_WIDTH * 3;

// Re-export Walker layout config for external use
export { DEFAULT_WALKER_CONFIG };
export type { WalkerLayoutConfig };

/**
 * Calculate the X offset of a node relative to its subtree's left edge.
 * @deprecated Use Walker layout positions directly instead
 */
const calculateNodeOffset = (_abo: TreeNodeData): number => {
  return NODE_WIDTH / 2;
};

/**
 * Calculate subtree width - kept for backward compatibility
 * @deprecated Use Walker layout positions directly instead
 */
const calculateSubtreeWidth = (_abo: TreeNodeData): number => {
  if (!_abo.expanded || !_abo.downlines?.length) {
    return NODE_WIDTH;
  }
  const childWidths = _abo.downlines.map((child) => calculateSubtreeWidth(child));
  const totalChildWidth = childWidths.reduce((sum, w) => sum + w, 0);
  const spacingNeeded = (_abo.downlines.length - 1) * MIN_SPACING;
  return totalChildWidth + spacingNeeded;
};

const getDisplayName = (abo: TreeNodeData, confidentialUserTranslatedString: string): string => {
  if (abo.aboAttributes.privacyFlag) {
    return confidentialUserTranslatedString;
  }
  return abo.displayName;
};

const addPointerCursor = (item: paper.Item, abo?: TreeNodeData, setSelectedAbo?: (abo: TreeNodeData) => void) => {
  item.onMouseEnter = () => {
    paper.view?.element?.classList.add("tree-view-poc__canvas--pointer");
  };
  item.onMouseLeave = () => {
    paper.view?.element?.classList.remove("tree-view-poc__canvas--pointer");
  };
  if (abo && setSelectedAbo) {
    item.onMouseDown = (event: paper.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      setSelectedAbo(abo);
    };
  }
};

/**
 * Check if a node's bounding box intersects with the viewport
 */
const isNodeInViewport = (x: number, y: number, viewport: ViewportBounds): boolean => {
  const nodeLeft = x - NODE_WIDTH / 2;
  const nodeRight = x + NODE_WIDTH / 2;
  const nodeTop = y - NODE_HEIGHT / 2;
  const nodeBottom = y + NODE_HEIGHT / 2;

  return !(
    nodeRight < viewport.minX - VIEWPORT_PADDING ||
    nodeLeft > viewport.maxX + VIEWPORT_PADDING ||
    nodeBottom < viewport.minY - VIEWPORT_PADDING ||
    nodeTop > viewport.maxY + VIEWPORT_PADDING
  );
};

/**
 * Check if a line segment intersects with the viewport (for connector lines)
 */
const isLineInViewport = (x1: number, y1: number, x2: number, y2: number, viewport: ViewportBounds): boolean => {
  const minX = Math.min(x1, x2);
  const maxX = Math.max(x1, x2);
  const minY = Math.min(y1, y2);
  const maxY = Math.max(y1, y2);

  return !(
    maxX < viewport.minX - VIEWPORT_PADDING ||
    minX > viewport.maxX + VIEWPORT_PADDING ||
    maxY < viewport.minY - VIEWPORT_PADDING ||
    minY > viewport.maxY + VIEWPORT_PADDING
  );
};

/**
 * Calculate viewport bounds from Paper.js view
 */
export const getViewportBounds = (): ViewportBounds | null => {
  if (!paper.view) return null;

  const center = paper.view.center;
  const zoom = paper.view.zoom;
  const viewSize = paper.view.viewSize;

  const halfWidth = viewSize.width / (2 * zoom);
  const halfHeight = viewSize.height / (2 * zoom);

  return {
    minX: center.x - halfWidth,
    maxX: center.x + halfWidth,
    minY: center.y - halfHeight,
    maxY: center.y + halfHeight,
  };
};

// Cache for Walker layout positions to avoid recalculation on pan/zoom
let cachedPositions: Map<number, { x: number; y: number }> | null = null;
let cachedRootAbo: TreeNodeData | null = null;
let cachedRootX = 0;
let cachedRootY = 0;

/**
 * Clear the position cache (call when tree structure changes)
 */
export const clearPositionCache = (): void => {
  cachedPositions = null;
  cachedRootAbo = null;
};

/**
 * Get or calculate Walker layout positions with caching
 */
const getOrCalculatePositions = (
  rootAbo: TreeNodeData,
  rootX: number,
  rootY: number,
): Map<number, { x: number; y: number }> => {
  // Check if we can use cached positions
  if (cachedPositions && cachedRootAbo === rootAbo && cachedRootX === rootX && cachedRootY === rootY) {
    return cachedPositions;
  }

  // Calculate new positions
  const walkerPositions = calculateWalkerLayout(rootAbo, DEFAULT_WALKER_CONFIG, rootX, rootY);
  const positions = new Map<number, { x: number; y: number }>();
  walkerPositions.forEach((pos) => {
    positions.set(pos.abo, { x: pos.x, y: pos.y });
  });

  // Cache the results
  cachedPositions = positions;
  cachedRootAbo = rootAbo;
  cachedRootX = rootX;
  cachedRootY = rootY;

  return positions;
};

/**
 * Main entry point for drawing the tree with viewport culling.
 * Only renders nodes visible in the current viewport for performance.
 */
export const drawTree = (
  rootAbo: TreeNodeData,
  rootX: number,
  rootY: number,
  setSelectedAbo: (abo: TreeNodeData) => void,
  toggleExpand: (id: string) => void,
  translations: DrawNodeTranslations,
  selectedNodeId?: string | null,
  viewport?: ViewportBounds | null,
  hideVolume = false,
): void => {
  // Get or calculate positions (cached if tree hasn't changed)
  const finalPositions = getOrCalculatePositions(rootAbo, rootX, rootY);

  // Get viewport bounds if not provided
  const viewportBounds = viewport ?? getViewportBounds();

  // Draw nodes with viewport culling
  drawNodeWithViewportCulling(
    rootAbo,
    finalPositions,
    setSelectedAbo,
    toggleExpand,
    translations,
    selectedNodeId,
    viewportBounds,
    hideVolume,
  );
};

/**
 * Draw nodes with viewport culling - only renders visible nodes
 */
const drawNodeWithViewportCulling = (
  abo: TreeNodeData,
  finalPositions: Map<number, { x: number; y: number }>,
  setSelectedAbo: (abo: TreeNodeData) => void,
  toggleExpand: (id: string) => void,
  translations: DrawNodeTranslations,
  selectedNodeId: string | null | undefined,
  viewport: ViewportBounds | null,
  hideVolume = false,
): void => {
  const position = finalPositions.get(abo.abo);
  if (!position) return;

  const { x, y } = position;
  const nodeHeight = NODE_HEIGHT;

  // Check if this node is in viewport (or if no viewport, render all)
  const nodeVisible = !viewport || isNodeInViewport(x, y, viewport);

  // Draw this node only if visible
  if (nodeVisible) {
    drawNodeVisuals(abo, x, y, setSelectedAbo, toggleExpand, translations, selectedNodeId, hideVolume);
  }

  // Process children and connecting lines
  const shouldDrawChildren = abo.expanded && !!abo.downlines?.length;
  if (shouldDrawChildren) {
    const verticalLineY = y + nodeHeight / 2 + 35;

    // Get child positions
    const childPositions = (abo.downlines ?? [])
      .map((child) => finalPositions.get(child.abo))
      .filter((pos): pos is { x: number; y: number } => pos !== undefined);

    // Draw vertical line from parent (if visible)
    if (!viewport || isLineInViewport(x, y + nodeHeight / 2, x, verticalLineY, viewport)) {
      const verticalLine = new paper.Path.Line(
        new paper.Point(x, y + nodeHeight / 2),
        new paper.Point(x, verticalLineY),
      );
      verticalLine.strokeColor = new paper.Color(0.5, 0.5, 0.5);
      verticalLine.strokeWidth = 2;
      verticalLine.sendToBack();
    }

    // Draw horizontal line connecting children (if visible)
    if (childPositions.length > 1) {
      const leftmost = Math.min(...childPositions.map((p) => p.x));
      const rightmost = Math.max(...childPositions.map((p) => p.x));

      if (!viewport || isLineInViewport(leftmost, verticalLineY, rightmost, verticalLineY, viewport)) {
        const horizontalLine = new paper.Path.Line(
          new paper.Point(leftmost, verticalLineY),
          new paper.Point(rightmost, verticalLineY),
        );
        horizontalLine.strokeColor = new paper.Color(0.5, 0.5, 0.5);
        horizontalLine.strokeWidth = 2;
        horizontalLine.sendToBack();
      }
    }

    // Draw children recursively
    (abo.downlines ?? []).forEach((child) => {
      const childPos = finalPositions.get(child.abo);
      if (!childPos) return;

      // Draw vertical line to child (if visible)
      if (!viewport || isLineInViewport(childPos.x, verticalLineY, childPos.x, childPos.y - nodeHeight / 2, viewport)) {
        const childVerticalLine = new paper.Path.Line(
          new paper.Point(childPos.x, verticalLineY),
          new paper.Point(childPos.x, childPos.y - nodeHeight / 2),
        );
        childVerticalLine.strokeColor = new paper.Color(0.5, 0.5, 0.5);
        childVerticalLine.strokeWidth = 2;
        childVerticalLine.sendToBack();

        if (child.internationalFlag) {
          childVerticalLine.dashArray = [5, 5];
        }
      }

      // Recursively draw child subtree
      drawNodeWithViewportCulling(
        child,
        finalPositions,
        setSelectedAbo,
        toggleExpand,
        translations,
        selectedNodeId,
        viewport,
        hideVolume,
      );
    });
  }
};

/**
 * Draw the visual elements of a single node (card, text, icons, etc.)
 */
const HIDDEN_VOLUME_PLACEHOLDER = "—";

const drawNodeVisuals = (
  abo: TreeNodeData,
  x: number,
  y: number,
  setSelectedAbo: (abo: TreeNodeData) => void,
  toggleExpand: (id: string) => void,
  translations: DrawNodeTranslations,
  selectedNodeId?: string | null,
  hideVolume = false,
): void => {
  const nodeWidth = NODE_WIDTH;
  const nodeHeight = NODE_HEIGHT;
  const isSelected = abo.abo.toString() === selectedNodeId;
  const isChina = isChinaAff(abo.aff.toString());
  const isExpanded = abo.expanded;

  // Main card with rounded corners
  const card = new paper.Shape.Rectangle(
    new paper.Rectangle(new paper.Point(x - nodeWidth / 2, y - nodeHeight / 2), new paper.Size(nodeWidth, nodeHeight)),
    new paper.Size(12, 12),
  );

  card.fillColor = new paper.Color(1, 1, 1);

  if (abo.internationalFlag) {
    card.strokeColor = new paper.Color(0, 0.7, 0);
    card.strokeWidth = 1;
    card.dashArray = [4, 4];
    card.dashOffset = 0;
  } else {
    card.strokeColor = new paper.Color(0.85, 0.85, 0.85);
    card.strokeWidth = 1;
  }

  const rawName = getDisplayName(abo, translations.confidentialUser);

  const nameText = new paper.PointText(new paper.Point(x - nodeWidth / 2 + 10, y - nodeHeight / 2 + 25));

  nameText.content = rawName;

  if (nameText.bounds.width > 132) {
    const ellipsis = "...";
    let name = rawName;

    while (name.length > 0) {
      name = name.slice(0, -1);
      nameText.content = name + ellipsis;

      if (nameText.bounds.width <= 132) {
        break;
      }
    }
  }

  nameText.fontFamily = "Arial, sans-serif";
  nameText.fontSize = 14;
  nameText.fontWeight = "bold";
  nameText.fillColor = new paper.Color(0.2, 0.2, 0.2);
  nameText.justification = "left";

  // KPI section
  const kpiY = y - nodeHeight / 2 + 45;
  const rowHeight = 22;
  const leftEdge = x - nodeWidth / 2 + 10;
  const bandHeight = 46;
  const bandTop = y + nodeHeight / 2 - bandHeight;

  if (!isChina) {
    // Row 1: Bonus
    const bonusValue = new paper.PointText(new paper.Point(leftEdge, kpiY));
    bonusValue.content = hideVolume ? HIDDEN_VOLUME_PLACEHOLDER : abo.kpis.BonusPercent.Formatted;
    bonusValue.fontFamily = "Arial, sans-serif";
    bonusValue.fontWeight = "bold";
    bonusValue.fontSize = 14;
    bonusValue.fillColor = new paper.Color(0, 0, 0);
    bonusValue.justification = "left";

    if (abo.isPabo) {
      const badgeWidth = 43;
      const badgeHeight = 21;
      const rightEdge = x + nodeWidth / 2;
      const badgePadding = 10;
      const goldColor = new paper.Color("#a86e49");

      const paboBadge = new paper.Shape.Rectangle(
        new paper.Rectangle(
          new paper.Point(rightEdge - badgeWidth - badgePadding, kpiY - badgeHeight / 2 - 4),
          new paper.Size(badgeWidth, badgeHeight),
        ),
        new paper.Size(3, 3),
      );
      paboBadge.fillColor = new paper.Color("#FFFFFF");
      paboBadge.strokeColor = goldColor;
      paboBadge.strokeWidth = 1.5;

      new paper.PointText({
        point: new paper.Point(rightEdge - badgeWidth / 2 - badgePadding, kpiY),
        content: translations.pabo,
        fontFamily: "Arial, sans-serif",
        fontWeight: "bold",
        fontSize: 11,
        fillColor: goldColor,
        justification: "center",
      });
    }

    // Row 2: PPV
    const pvLabel = new paper.PointText(new paper.Point(leftEdge, kpiY + rowHeight));
    pvLabel.content = translations.ppv;
    pvLabel.fontFamily = "Arial, sans-serif";
    pvLabel.fontSize = 14;
    pvLabel.fillColor = new paper.Color(0.4, 0.4, 0.4);
    pvLabel.justification = "left";

    const pvValueOffset = Math.max(40, pvLabel.bounds.width + 8);
    const pvValue = new paper.PointText(new paper.Point(leftEdge + pvValueOffset, kpiY + rowHeight));
    pvValue.content = hideVolume ? HIDDEN_VOLUME_PLACEHOLDER : abo.kpis.PersonalPV.Formatted;
    pvValue.fontFamily = "Arial, sans-serif";
    pvValue.fontWeight = "bold";
    pvValue.fontSize = 14;
    pvValue.fillColor = new paper.Color(0, 0, 0);
    pvValue.justification = "left";

    // Row 3: GPV
    const gpvLabel = new paper.PointText(new paper.Point(leftEdge, kpiY + rowHeight * 2));
    gpvLabel.content = translations.gpv;
    gpvLabel.fontFamily = "Arial, sans-serif";
    gpvLabel.fontSize = 14;
    gpvLabel.fillColor = new paper.Color(0.4, 0.4, 0.4);
    gpvLabel.justification = "left";

    const gpvValueOffset = Math.max(40, gpvLabel.bounds.width + 8);
    const gpvValue = new paper.PointText(new paper.Point(leftEdge + gpvValueOffset, kpiY + rowHeight * 2));
    gpvValue.content = hideVolume ? HIDDEN_VOLUME_PLACEHOLDER : abo.kpis.GroupPV.Formatted;
    gpvValue.fontFamily = "Arial, sans-serif";
    gpvValue.fontWeight = "bold";
    gpvValue.fontSize = 14;
    gpvValue.fillColor = new paper.Color(0, 0, 0);
    gpvValue.justification = "left";
  }

  // Row 4: Group icon and number (matches PPV/GPV size and spacing)
  const groupRowY = kpiY + rowHeight * 3;
  const groupIcon = paper.project.importSVG(groupSvg);
  groupIcon.scaling = new paper.Point(1.1, 1.1);
  groupIcon.position = new paper.Point(leftEdge + 8, groupRowY - 5);

  if (!isChina) {
    const groupText = new paper.PointText(new paper.Point(leftEdge + 24, groupRowY));
    groupText.content = hideVolume
      ? HIDDEN_VOLUME_PLACEHOLDER
      : (abo.sponsoringStats?.groupCount ?? 0).toLocaleString();
    groupText.fontFamily = "Arial, sans-serif";
    groupText.fontWeight = "bold";
    groupText.fontSize = 14;
    groupText.fillColor = new paper.Color(0, 0, 0);
    groupText.justification = "left";
  }

  // Ellipses click area and icon (aligned with the group row)
  const ellipsesY = groupRowY;
  const ellipsesClickArea = new paper.Shape.Rectangle(
    new paper.Rectangle(new paper.Point(x + nodeWidth / 2 - 36, ellipsesY - 17), new paper.Size(36, 26)),
  );
  ellipsesClickArea.fillColor = new paper.Color("#ffffff");
  ellipsesClickArea.strokeColor = null;

  const ellipsesIcon = paper.project.importSVG(ellipsesSvg);
  ellipsesIcon.position = new paper.Point(x + nodeWidth / 2 - 20, ellipsesY - 5);
  ellipsesIcon.scaling = new paper.Point(1.1, 1.1);

  addPointerCursor(ellipsesClickArea, abo, setSelectedAbo);
  addPointerCursor(ellipsesIcon, abo, setSelectedAbo);

  if (abo.watchlist && !isChina) {
    const eyeIcon = paper.project.importSVG(eyeSvg);
    eyeIcon.scaling = new paper.Point(0.9, 0.9);
    eyeIcon.position = new paper.Point(x + nodeWidth / 2 - 20, kpiY + rowHeight - 5);
    eyeIcon.fillColor = new paper.Color(0, 0, 0);
  }

  // Shaded area at bottom
  const DEFAULT_COLOR: AwardColor = { bg: "#cccccc", fg: "#000000" };
  const color = AWARD_RANK_TO_COLOR[abo.currentAwardRank] ?? DEFAULT_COLOR;
  const pillCenterY = bandTop + bandHeight / 2;

  const buttonBg = new paper.Shape.Rectangle(
    new paper.Rectangle(new paper.Point(x - nodeWidth / 2, bandTop), new paper.Size(nodeWidth, bandHeight)),
    new paper.Size(12, 12),
  );
  buttonBg.fillColor = new paper.Color(color.bg);
  buttonBg.strokeColor = null;

  const topBg = new paper.Shape.Rectangle(
    new paper.Rectangle(new paper.Point(x - nodeWidth / 2, bandTop), new paper.Size(nodeWidth, bandHeight / 2)),
    new paper.Size(0, 0),
  );
  topBg.fillColor = new paper.Color(color.bg);
  topBg.strokeColor = null;

  // Country code badge for international ABOs
  if (abo.internationalFlag && abo.aboAttributes?.isoCountry) {
    const badgePillWidth = 30;
    const badgePillHeight = 20;
    const badgePillX = x + nodeWidth / 2 - badgePillWidth / 2 - 25;
    const badgePillY = y + nodeHeight / 2 - badgePillHeight / 2 - 16;

    const countryBadge = new paper.Shape.Rectangle(
      new paper.Rectangle(new paper.Point(badgePillX, badgePillY), new paper.Size(badgePillWidth, badgePillHeight)),
      new paper.Size(5, 5),
    );
    countryBadge.fillColor = new paper.Color(color.bg);
    countryBadge.strokeColor = new paper.Color(color.fg);
    countryBadge.strokeWidth = 1.5;

    const countryCodeText = new paper.PointText(
      new paper.Point(badgePillX + badgePillWidth / 2, badgePillY + badgePillHeight / 2 + 4),
    );
    countryCodeText.content = abo.aboAttributes.isoCountry;
    countryCodeText.fontFamily = "Arial, sans-serif";
    countryCodeText.fontSize = 11;
    countryCodeText.fontWeight = "bold";
    countryCodeText.fillColor = new paper.Color(color.fg);
    countryCodeText.justification = "center";
    addPointerCursor(countryBadge);
    addPointerCursor(countryCodeText);
  }

  // Plus/minus button
  // For international nodes: only show the minus (collapse) button when already expanded.
  // Never show the plus (expand) button on international nodes — users must not drill in further.
  const canShowButton = abo.downlines?.length && (!abo.internationalFlag || isExpanded);
  if (canShowButton) {
    const svgContent = isExpanded ? chevronUp : chevronDown;
    const pillCenter = new paper.Point(x, pillCenterY);
    const pillHeight = 28;
    const pillPadding = 12;
    const gapBetween = 8;
    const chevronWidth = 14;

    const groupNumberText = new paper.PointText(new paper.Point(0, pillCenter.y + 5));
    groupNumberText.content = (abo.downlines?.length ?? 0).toLocaleString();
    groupNumberText.fontFamily = "Arial, sans-serif";
    groupNumberText.fontWeight = "bold";
    groupNumberText.fontSize = 16;
    groupNumberText.fillColor = new paper.Color("#2c2c2c");
    groupNumberText.justification = "left";

    const pillWidth = pillPadding * 2 + groupNumberText.bounds.width + gapBetween + chevronWidth;

    const pill = new paper.Shape.Rectangle(
      new paper.Rectangle(
        new paper.Point(pillCenter.x - pillWidth / 2, pillCenter.y - pillHeight / 2),
        new paper.Size(pillWidth, pillHeight),
      ),
      new paper.Size(pillHeight / 2, pillHeight / 2),
    );
    pill.fillColor = new paper.Color("#F4F4F4");
    pill.strokeColor = null;
    groupNumberText.bringToFront();

    groupNumberText.position = new paper.Point(
      pillCenter.x - pillWidth / 2 + pillPadding + groupNumberText.bounds.width / 2,
      groupNumberText.position.y,
    );

    const chevronIcon = paper.project.importSVG(svgContent);
    const chevronTargetHeight = 8;
    const chevronScale = chevronTargetHeight / chevronIcon.bounds.height;
    chevronIcon.scaling = new paper.Point(chevronScale, chevronScale);
    chevronIcon.position = new paper.Point(pillCenter.x + pillWidth / 2 - pillPadding - chevronWidth / 2, pillCenter.y);
    chevronIcon.fillColor = new paper.Color("#707070");

    if (chevronIcon.children) {
      chevronIcon.children.forEach((child: paper.Item) => {
        if ((child as paper.PathItem).fillColor) {
          (child as paper.PathItem).fillColor = new paper.Color("#707070");
          (child as paper.PathItem).strokeColor = new paper.Color("#707070");
        }
      });
    }

    const handleClick = (event: paper.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      toggleExpand(abo.abo.toString());
    };

    pill.onMouseDown = handleClick;
    groupNumberText.onMouseDown = handleClick;
    chevronIcon.onMouseDown = handleClick;
    buttonBg.onMouseDown = handleClick;
    topBg.onMouseDown = handleClick;

    addPointerCursor(pill);
    addPointerCursor(groupNumberText);
    addPointerCursor(chevronIcon);
  }

  // Card border overlay
  const cardBorder = new paper.Shape.Rectangle(
    new paper.Rectangle(new paper.Point(x - nodeWidth / 2, y - nodeHeight / 2), new paper.Size(nodeWidth, nodeHeight)),
    new paper.Size(12, 12),
  );
  cardBorder.fillColor = null;
  if (abo.internationalFlag) {
    cardBorder.strokeColor = new paper.Color(0, 0.7, 0);
    cardBorder.dashArray = [4, 4];
  } else {
    cardBorder.strokeColor = new paper.Color(0.85, 0.85, 0.85);
  }
  cardBorder.strokeWidth = 1;

  // Selection highlight
  if (isSelected) {
    const selectionHighlight = new paper.Shape.Rectangle(
      new paper.Rectangle(
        new paper.Point(x - nodeWidth / 2 - 2, y - nodeHeight / 2 - 2),
        new paper.Size(nodeWidth + 4, nodeHeight + 4),
      ),
      new paper.Size(14, 14),
    );
    selectionHighlight.fillColor = null;
    selectionHighlight.strokeColor = new paper.Color(0.25, 0.25, 0.25);
    selectionHighlight.strokeWidth = 4;
  }

  // Who's New highlight
  if (abo.whosNewAbo) {
    const whosNewHighlight = new paper.Shape.Rectangle(
      new paper.Rectangle(
        new paper.Point(x - nodeWidth / 2, y - nodeHeight / 2),
        new paper.Size(nodeWidth, nodeHeight),
      ),
      new paper.Size(12, 12),
    );
    whosNewHighlight.fillColor = null;
    whosNewHighlight.strokeColor = new paper.Color("#FFD700");
    whosNewHighlight.strokeWidth = 8;
  }

  addPointerCursor(buttonBg);
  addPointerCursor(topBg);
};

/**
 * Legacy export for backward compatibility.
 */
export const drawNode = (
  abo: TreeNodeData,
  x: number,
  y: number,
  setSelectedAbo: (abo: TreeNodeData) => void,
  toggleExpand: (id: string) => void,
  translations: DrawNodeTranslations,
  selectedNodeId?: string | null,
  viewport?: ViewportBounds | null,
  hideVolume = false,
): number => {
  drawTree(abo, x, y, setSelectedAbo, toggleExpand, translations, selectedNodeId, viewport, hideVolume);
  return y + NODE_HEIGHT + 30;
};

/**
 * Calculate final positions for nodes using Walker's algorithm.
 */
export const getNodePositions = (rootAbo: TreeNodeData, rootX: number, rootY: number): Map<number, number> => {
  const positions = getOrCalculatePositions(rootAbo, rootX, rootY);
  const positionMap = new Map<number, number>();
  positions.forEach((pos, abo) => {
    positionMap.set(abo, pos.x);
  });
  return positionMap;
};

/**
 * Get full position data (x and y) for all nodes using Walker's algorithm.
 */
export const getFullNodePositions = (
  rootAbo: TreeNodeData,
  rootX: number,
  rootY: number,
): Map<number, { x: number; y: number }> => {
  return getOrCalculatePositions(rootAbo, rootX, rootY);
};

// Export constants for use in TreeView
export { NODE_WIDTH, NODE_HEIGHT, MIN_SPACING, calculateSubtreeWidth, calculateNodeOffset };
